import { Injectable } from '@angular/core'

import { RedirectHelper, Utils, DomUtils } from '../../'
import { MergedExceptionHandler } from './'
import {
  LocalLoggerExceptionHandler,
  AuthenticationExceptionHandler,
  SentryExceptionHandler,
  TokenExpiredExceptionHandler,
  UiExceptionHandler,
  SelectiveExceptionHandler
} from '../'

@Injectable()
export class MergedExceptionHandlerBuilder {
    public constructor(
      private _redirectHelper: RedirectHelper,
      private _utils: Utils,
      private _domUtils: DomUtils,
      private _ravenConfigs: {}
    ) {}
    public localBuild(): MergedExceptionHandler {
      const handlers = this.buildCommonHandlers()
      handlers.push(new LocalLoggerExceptionHandler())
      return new MergedExceptionHandler(handlers)
    }

    public productionBuild(): MergedExceptionHandler {
      return new MergedExceptionHandler(this.buildCommonHandlers())
    }

    private buildCommonHandlers(): SelectiveExceptionHandler[] {
      return [
        new AuthenticationExceptionHandler(this._redirectHelper),
        new SentryExceptionHandler(this._ravenConfigs),
        new TokenExpiredExceptionHandler(this._redirectHelper, this._domUtils),
        new UiExceptionHandler(this._domUtils),
      ]
    }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/merged-exception-handler/merged-exception-handler.builder.ts